/* Developed by: Philip C. Diaz
   Passion: Javascript Prototype Developer | Senior Frontend Developer
   Website: https://philipdiaz.info
   Email: diazphi@gmail.com

   License: Forever Free, you are freely to improve and modify.
*/      
"use strict";
window.theme = window.theme || {}
theme.ProductCustomInput = function() {

    function ProductCustomInput() {
        this.btn = {
           imageplus: document.querySelectorAll('.custom_img_file_input > button.custom_img_plus'),
           imageminus: document.querySelectorAll('.custom_img_file_input > button.custom_img_minus')
        }
        this.input = {
            fileupload: document.querySelectorAll('.custom_img_file_input > input[type="file"]')
        }
        this.container = {
             custominput: document.querySelectorAll('.custom_img_file_input')
        }
        this.load();
    }

    ProductCustomInput.prototype.load = function() {
        var _ = this; 
        if(_.btn.imageplus.length>0) {
            _.btn.imageplus.forEach(btn => {
                btn.addEventListener('click', event => {
                    if(Number(_.container.custominput.length) > Number(event.target.closest('button').getAttribute('data-input-index'))) {
                        _.container.custominput[event.target.closest('button').getAttribute('data-input-index')].classList.add('active');
                    }                  
                })
            })
        }
        if(_.btn.imageminus.length>0) {
            _.btn.imageminus.forEach(btn => {
                btn.addEventListener('click', event => {
                    if(Number(event.target.closest('button').getAttribute('data-input-index')) > 0) {
                        _.container.custominput[event.target.closest('button').getAttribute('data-input-index')].classList.remove('active');
                        _.input.fileupload[event.target.closest('button').getAttribute('data-input-index')].value = '';
                    } else {
                        _.input.fileupload[0].value = '';
                    }                 
                })
            })
        }
        if(_.input.fileupload.length>0) {
            _.input.fileupload.forEach(input => {
                input.addEventListener('change', event => {
                    if(Number(_.container.custominput.length) > Number(event.target.closest('input').getAttribute('data-input-index'))) {
                        _.container.custominput[event.target.closest('input').getAttribute('data-input-index')].classList.add('active');
                    }                  
                })
            })
        }
    }

  theme.ProductCustomInput = new ProductCustomInput;

}

theme.ProductCustomInput();